import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { News } from './news.model';
import { NewsService } from './news.service';

@Injectable()
export class NewsResolver implements Resolve<News> {
  constructor(
    private newsService: NewsService,
    private router: Router
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    let id = route.params['id'];

    if (id === 'new') {
      return this.newsService
        .addNews()
        .map((news) => {
          return news;
        });
    }

    return this.newsService
      .getNews(id)
      .map((news) => {
        if (news) {
          return news;
        }
        // Return a new object, because we're going to create a new one
        return new News();
      })
      .catch((error: any) => {
        console.log(`${error}. Redirecionado para a lista de noticias`);
        // TODO: Change to /news
        this.router.navigate(['/news']);
        return Observable.of(null);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/noticias/shared/news.resolver.ts